import { domContentLoadEvent } from './domContentLoadEvent';

function setupTabs() {
    const tabs = document.querySelectorAll('.tab');

    tabs.forEach((tab) => {
        const tabItems = tab.querySelectorAll('.tab-item');

        tabItems.forEach((tabItem, index) => {
            tabItem.addEventListener('click', () => {
                if (tabItem.tagName === 'A') {
                    return;
                }

                changeTab(tab, index);
            });
        });
    });
}

function changeTab(tab, tabIndex) {
    const tabItems = tab.querySelectorAll('.tab-item');
    const tabPanes = tab.querySelectorAll('.tab-pane');

    tabItems.forEach((tabItem) => {
        tabItem.classList.remove('active');
    });

    tabPanes.forEach((tabPane) => {
        tabPane.classList.remove('active');
    });

    tabItems[tabIndex].classList.add('active');
    tabPanes[tabIndex].classList.add('active');
}

domContentLoadEvent(setupTabs);
